import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { withTranslation, useTranslation } from "react-i18next";
import Terms from "./Terms";

const CopyRightAndPrivacyComponent = (props) => {
  const { t } = useTranslation();
  useEffect(() => {
    const termsProps = {
      regexFormColor: props.regexFormColor,
      regexFormFontSize: props.regexFormFontSize,
      titleColor: props.titleColor,
      subtitleColor: props.subtitleColor,
      backgroundColorTopBar: props.backgroundColorTopBar,
      appHomeTextCallToAction: props.appHomeTextCallToAction,
      allTerms: [{ regexForm: [t("COPYWRITE_PRIVACY_POLICY")] }],
      noPadding: true,
    };
    const sections = ["desktop-container", "content"];
    sections.forEach((sectionId, index) => {
      const section = document.getElementById(sectionId);
      const termsId = `terms-component-${index}`;
      if (section) {
        let termsComponent = document.getElementById(
          `terms-component-${index}`
        );
        if (termsComponent) {
          termsComponent.remove();
        }

        termsComponent = document.createElement("div");
        termsComponent.id = termsId;
        termsComponent.className = `${index === 0
            ? "hidden desktop:block"
            : "flex flex-1 pb-24 justify-center items-end block desktop:hidden"
          }`;
        ReactDOM.render(<Terms {...termsProps} copyright />, termsComponent);
        section.appendChild(termsComponent);
      }
    });
  }, [
    props.regexFormColor,
    props.regexFormFontSize,
    props.titleColor,
    props.subtitleColor,
    props.backgroundColorTopBar,
    props.appHomeTextCallToAction,
    t,
  ]);

  return null;
};

export default withTranslation()(CopyRightAndPrivacyComponent);
